import React, { useEffect } from 'react';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { StopSearching } from './components/StopSearching';
import { ReadyToUse } from './components/ReadyToUse';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BonusSection } from './components/BonusSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
interface AppProps {
  /** Show the rotating "just purchased" social-proof popup. */
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '943022892065433');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="d57d4waue6fw">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=943022892065433&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="d3mil6oj2ni1" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-white text-carbon" data-id="element-2" data-mp="3glnzs6fvxakv">
        <main data-id="element-3" data-mp="3bnmerfywf16r">
          <Hero data-id="element-4" data-mp="3bo4mp9uxb3ui" />
          <ProblemSection data-id="element-5" data-mp="3bkgqg2y3g3c3" />
          <StopSearching data-id="element-6" data-mp="3qbpnuy88mszs" />
          <ReadyToUse data-id="element-7" data-mp="3qc93u9ebv7b6" />
          <SystemSection data-id="element-8" data-mp="3qcinzgcoyk8y" />
          <ModulesSection data-id="element-9" data-mp="3lkhdnzz333lk" />
          <PreviewCarousel data-id="element-10" data-mp="3lk7mi92ayqea" />
          <BonusSection data-id="element-11" data-mp="3liwjwcklfoor" />
          <DifferentiatorSection data-id="element-12" data-mp="3liehey7c8e8e" />
          <Offer data-id="element-13" data-mp="2xud9nrhzh1u1" />
          <Guarantee data-id="element-14" data-mp="2xtv7ke8n3te7" />
          <Testimonials data-id="element-15" data-mp="2xtbw9gdhw395" />
          <FAQ data-id="element-16" data-mp="2xsk4kgn0qpo5" />
          <FinalCTA data-id="element-17" data-mp="2sw207hvlotcc" />
        </main>
        <Footer data-id="element-18" data-mp="2sv0pjeihy8v5" />
      </div>

      {showPurchasePopup && <PurchaseToast data-id="element-19" data-mp="18driltpr7bcr" />}
    </>;
}